export const providersWelcomeText =
  "our mission is to increase access to high-quality, nuanced, and personalized mental healthcare by building tools that accelerate the human connection essential for meaningful care.";

export const OWNER_OPTIONS = {
  unassigned: "unassigned",
};

export const REGEX_SPLIT_DASH = /-(?!in\b)/;

export const TEXT_MAX_LENGTH = 2000;
export const TEXT_MEDIUM_LENGTH = 1000;
export const LARGE_TEXT_LENGTH = 5000;
export const TEXT_NAME_MAX_LENGTH = 100;
export const SHORT_TEXT_MAX_LENGTH = 500;

export const TEAM_MEMBER_DATA_TOKEN = "data-token" as const;
